import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser } from "../hooks/useCurrentUser";
import isKibtek from "../helpers/is-kibtek";

/** Keeps the Events & Outages pages out of reach for every other company. */
const KibtekOnlyRoute: FC = function () {
  const currentUser = useCurrentUser();
  return isKibtek(currentUser) ? <Outlet /> : <Navigate to="/" replace />;
};

export default KibtekOnlyRoute;
